import styled from 'styled-components';

export const StyleDropdown = styled.div`
.Dropdown-menu {
    text-align: ${props => (props.formName === 'M6-8') ? 'center' : 'left'};
}
`;
